import React, {useState} from "react";
import axios from 'axios';
import {ToastsContainer, ToastsContainerPosition, ToastsStore} from "react-toasts";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import BoxAlert from "../../sharecomponents/BoxAlert";
import {API_URL} from "../../../utils/Common";

const initialFormValvulas = Object.freeze({
    codigo: '',
    largo: '0',
    no_camas: '0',
    agua: '',
    micro: 'Ninguno',
    electrificada: 'Ninguno',
    hoops: 'Ninguno',
    sombra: 'Ninguno'
});

const initialFormRancho = Object.freeze({
    rancho: ''
})

const AltaRancho = (props) => {

    const [valvulas, stateValvulas] = useState([]);
    const [formValvulas, stateFormValvulas] = useState(initialFormValvulas);
    const [formRancho, updateFormRancho] = useState(initialFormRancho);

    const handlerChangeValvula = (e) => {
        stateFormValvulas({
            ...formValvulas,
            [e.target.name]: e.target.value.trim()
        })
    }

    const handlerChangeRancho = e => {
        updateFormRancho({
            ...formRancho,
            [e.target.name]: e.target.value.trim()
        })
    }

    const handlerAddValvula = (e) => {
        e.preventDefault();
        console.log(formValvulas);

        valvulas.push(formValvulas);
        let newArr = [...valvulas];
        stateValvulas(newArr);

        console.log(valvulas);
    }

    const onSubmit = e => {
        e.preventDefault();
        if (valvulas.length === 0) {
            ToastsStore.error("Es necesario agregar válvulas para registrar el Rancho");
            return
        }
        console.log(formRancho, valvulas);
        axios.post(API_URL + '/rancho/setRancho', {formRancho, valData: valvulas})
            .then(r => {
                console.log(r);
                props.history.goBack();
            }).catch(err => console.log(err));
    }

    return (
        <div className="w-full p-3">
            <div className="bg-white border rounded shadow">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <HeadRegresar titulo="Registro del Rancho" history={props.history} />
                </div>
                <div className="p-5 rounded-b">
                    {/** Formulario del rancho */}
                    <h3 className="text-orange-900 font-bold">Datos del Rancho</h3>
                    <hr className="mb-3"/>
                    <div className="flex max-w-full max-h-full">
                        <div className="w-1/2 p-2 h-auto">
                            <form onSubmit={onSubmit} className="mb-3">
                                <div className="mb-6 md:mb-0">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Nombre del Rancho:
                                    </label>
                                    <input className="uppercase text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                           onChange={handlerChangeRancho}
                                           type="text" name="rancho"/>
                                </div>
                                <button type="submit" className="mt-3 bg-orange-700 hover:bg-orange-700 text-white py-2 px-4 rounded shadow">
                                    Registrar
                                </button>
                            </form>
                        </div>
                        <div className="w-1/2 p-2 h-auto">
                            { valvulas.length === 0 && <BoxAlert titulo="Nota" mensaje="Es necesario agregar válvulas para crear el Rancho"/>}
                        </div>
                    </div>
                    <h3 className="text-orange-900 font-bold">Válvulas del Rancho</h3>
                    <hr className="mb-3"/>
                    <div className="flex max-w-full max-h-full">
                        {/** Formulario alta de la valvula se guarda en un array */}
                        <div className="w-1/2 p-2 h-auto">
                            <h4 className="text-orange-900">Agregar Válvula</h4>
                            <hr className="mb-3"/>
                            <form onSubmit={handlerAddValvula}>
                                <div className="flex flex-wrap my-2">
                                    <div className="w-1/3 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Código Válvula:
                                        </label>
                                        <input className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               name="codigo"
                                               value={formValvulas.codigo}
                                               type="text" onChange={handlerChangeValvula} />
                                    </div>
                                    <div className="w-1/3 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Largo:
                                        </label>
                                        <input className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               name="largo"
                                               value={formValvulas.largo}
                                               type="number" step="any" onChange={handlerChangeValvula} />
                                    </div>
                                    <div className="w-1/3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            No. Camas:
                                        </label>
                                        <input className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               name="no_camas"
                                               value={formValvulas.no_camas}
                                               type="number" onChange={handlerChangeValvula} />
                                    </div>
                                </div>
                                <div className="flex flex-wrap my-2">
                                    <div className="w-1/2 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Agua:
                                        </label>
                                        <input className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               name="agua"
                                               value={formValvulas.agua}
                                               type="text" onChange={handlerChangeValvula} />
                                    </div>
                                    <div className="w-1/2 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Micro:
                                        </label>
                                        <div className="relative">
                                            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="micro"
                                                    value={formValvulas.micro}
                                                    onChange={handlerChangeValvula}>
                                                <option value="Ninguno">Ninguno</option>
                                                <option value="Si">Si</option>
                                                <option value="No">No</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-wrap my-2">
                                    <div className="w-1/3 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Electrificada:
                                        </label>
                                        <div className="relative">
                                            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="electrificada"
                                                    value={formValvulas.electrificada}
                                                    onChange={handlerChangeValvula}>
                                                <option value="Ninguno">Ninguno</option>
                                                <option value="Si">Si</option>
                                                <option value="No">No</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Hoops:
                                        </label>
                                        <div className="relative">
                                            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="hoops"
                                                    value={formValvulas.hoops}
                                                    onChange={handlerChangeValvula}>
                                                <option value="Ninguno">Ninguno</option>
                                                <option value="Si">Si</option>
                                                <option value="No">No</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Sombra:
                                        </label>
                                        <div className="relative">
                                            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="sombra"
                                                    value={formValvulas.sombra}
                                                    onChange={handlerChangeValvula}>
                                                <option value="Ninguno">Ninguno</option>
                                                <option value="Si">Si</option>
                                                <option value="No">No</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="text-xs ml-2 bg-orange-700 hover:bg-orange-700 text-white py-2 px-4 rounded shadow">
                                    Agregar
                                </button>
                            </form>
                        </div>
                        {/** Listado de las valvulas ingresadas (ojo no guardadas) */}
                        <div className="w-1/2 p-2 h-auto">
                            <h4 className="text-orange-900">Válvulas del Rancho</h4>
                            <hr className="mb-3"/>
                            <table className="table-fixed mt-1 w-full">
                                <thead>
                                <tr className="border border-orange-200 text-xs text-white content-center bg-orange-800">
                                    <th>Código Válvula</th>
                                    <th>Largo</th>
                                    <th>No. Camas</th>
                                    <th>Agua</th>
                                    <th>Micro</th>
                                    <th>Electrificada</th>
                                    <th>Hoops</th>
                                    <th>Sombra</th>
                                </tr>
                                </thead>
                                <tbody>
                                { valvulas.length === 0 &&
                                    <tr>
                                        <td className="text-sm text-orange-900 border px-4 py-2" colSpan="8">No se han ingresado valvulas</td>
                                    </tr>
                                }
                                {
                                    valvulas.map((a, i) => {
                                        return(
                                            <tr key={i} className="text-xs">
                                                <td className="border px-4 py-2">{ a.codigo }</td>
                                                <td className="border px-4 py-2">{ a.largo }</td>
                                                <td className="border px-4 py-2">{ a.no_camas }</td>
                                                <td className="border px-4 py-2">{ a.agua }</td>
                                                <td className="border px-4 py-2">{ a.micro }</td>
                                                <td className="border px-4 py-2">{ a.electrificada }</td>
                                                <td className="border px-4 py-2">{ a.hoops }</td>
                                                <td className="border px-4 py-2">{ a.sombra }</td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>
        </div>
    );
}

export default AltaRancho;
